import minimatch from 'minimatch';

// Didomi stores web targets as domains and app targets as mobile app ids, so
// only web properties can be linked to a flow.
export const MATCHABLE_PROPERTY_TYPES = ['web'];

// Merge the `/domain-flow-ids` responses of several Didomi organizations. Each
// response is keyed by Sourcepoint platform then target, e.g.
// { web: { "www.example.com": "DDF-8821" }, app: {}, amp: {}, ott: {} }.
// Conflicts across organizations aren't handled yet; the first organization wins.
export const mergeDomainFlowIds = (maps) => {
  const merged = {};
  for (const map of maps) {
    for (const [platform, targets] of Object.entries(map || {})) {
      merged[platform] = merged[platform] || {};
      for (const [target, flowId] of Object.entries(targets || {})) {
        if (!(target in merged[platform])) merged[platform][target] = flowId;
      }
    }
  }
  return merged;
};

// Find the Didomi flow linked to an SP property among the targets for its
// platform, mirroring how Didomi itself matches domains when serving the SDK config:
// - comparisons are case-insensitive
// - an SP wildcard property (contains `*`) only links to an identical target
// - otherwise prefer an exact match, then fall back to the first wildcard
//   target (in Didomi's order) that matches the domain
// Returns the flow id, or null when nothing matches.
export const findLinkedFlowId = (property, domainFlowIds) => {
  if (!property?.domain || !MATCHABLE_PROPERTY_TYPES.includes(property.type)) return null;

  const domain = property.domain.trim().toLowerCase();
  const targets = Object.entries(domainFlowIds?.[property.type] || {}).map(([target, flowId]) => [target.toLowerCase(), flowId]);

  const exact = targets.find(([target]) => target === domain);
  if (exact) return exact[1];
  if (domain.includes('*')) return null;

  const wildcard = targets.find(([target]) => target.includes('*') && minimatch(domain, target));
  return wildcard ? wildcard[1] : null;
};
